import * as React from 'react';

import * as I18n from 'i18n-js';
import * as classNames from 'classnames';
import { CommonsMParticleListing } from '../schemas/rql';
import withMParticleListings from '@reverbdotcom/commons/dist/components/with_mparticle_listings';
import bind from '@reverbdotcom/commons/dist/bind';
import { destroy, post } from './api_request';

import {
  ProductActionType,
  MParticleEventName,
  trackEvent,
} from '@reverbdotcom/commons/dist/elog/mparticle_tracker';

interface IProps {
  listingIds: string[];
  cartItemId: string;
  canMoveToWatchList?: boolean;
  canRemoveFromCart?: boolean;
  mParticleListings?: CommonsMParticleListing.Listings[];
}

interface IState {
  showConfirmation: boolean;
}

function track(
  listing: CommonsMParticleListing.Listings,
  productActionType: ProductActionType,
): void {
  if (!listing) return;

  trackEvent({
    listing,
    productActionType,
    eventName: MParticleEventName.ProductAction,
  });
}

export class CartItemActions extends React.Component<IProps, IState> {
  static defaultProps: Partial<IProps> = {
    mParticleListings: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      showConfirmation: false,
    };
  }

  get listingId() {
    return this.props.listingIds[0];
  }

  get listing() {
    return this.props.mParticleListings[0];
  }

  @bind
  moveToWatchList() {
    post(`/cart/${this.props.cartItemId}/move_to_watchlist`, {}, {}, '3.0').then(
      () => {
        track(this.listing, ProductActionType.RemoveFromCart);
        track(this.listing, ProductActionType.AddToWishlist);
        window.location.reload();
      },
    );
  }

  @bind
  removeFromCart() {
    destroy(`/cart/${this.listingId}`, {}, {}, '3.0').then(() => {
      track(this.listing, ProductActionType.RemoveFromCart);
      window.location.reload();
    });
  }

  @bind
  setConfirmation(showConfirmation) {
    this.setState({ showConfirmation });
  }

  render() {
    const {
      canMoveToWatchList,
      canRemoveFromCart,
    } = this.props;

    const confirmationSectionClasses = classNames(
      'mobile-width-100 mtb-half panel pull-left',
      { hidden: !this.state.showConfirmation },
    );

    const buttonClasses = classNames(
      'inline-list mt-half small',
      { hidden: this.state.showConfirmation },
    );

    return (
      <>
        <ul className={buttonClasses}>
          {canMoveToWatchList &&
            <li className="margined-right hidden-mobile">
              <a
                className="color-gray"
                data-move-to-watchlist
                onClick={this.moveToWatchList}
                rel="nofollow"
              >
                <span className="fa fa-star"></span> {I18n.t('discovery.removeFromCart.moveToWatchList')}
              </a>
            </li>
          }
          {canRemoveFromCart &&
            <li>
              <a
                className="color-gray remove-link"
                data-toggle-confirmation
                onClick={() => this.setConfirmation(true)}
                rel="nofollow"
              >
                <span className="fa fa-times"></span> {I18n.t('discovery.removeFromCart.remove')}
              </a>
            </li>
          }
        </ul>

        <div className="clearfix">
          <div
            className={confirmationSectionClasses}
            data-confirmation-section
          >
            <p className="small mb-half">
              {I18n.t('discovery.removeFromCart.confirmation')}
            </p>
            <a
              className="button button--mini mobile-width-100 mobile-mb-half"
              data-cancel-remove-from-cart
              onClick={() => this.setConfirmation(false)}
              rel="nofollow"
            >
              {I18n.t('discovery.removeFromCart.no')}
            </a>
            &nbsp;
            <a
              className="button button--mini mobile-width-100"
              data-confirm-remove-from-cart
              onClick={this.removeFromCart}
              rel="nofollow"
            >
              {I18n.t('discovery.removeFromCart.yes')}
            </a>
          </div>
        </div>
      </>
    );
  }
}

export default withMParticleListings()(CartItemActions) as React.ComponentClass<IProps>;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/cart_item_actions.tsx